import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate'
import LZString from 'lz-string';

Vue.use(PiniaVuePlugin); // Vue 2

const compressedStorage = {
    getItem: (key) => {
        const data = localStorage.getItem(key)
        return data ? JSON.parse(LZString.decompress(data)) : null
    },
    setItem: (key, value) => {
        localStorage.setItem(key, LZString.compress(JSON.stringify(value)))
    },
    removeItem: (key) => {
        localStorage.removeItem(key)
    }
}

const pinia = createPinia();
pinia.use(createPersistedState({ storage: compressedStorage }));

export default pinia;


